import { render, staticRenderFns } from "./DemoLogin.vue?vue&type=template&id=2cd3f980&scoped=true&"
import script from "./DemoLogin.vue?vue&type=script&lang=js&"
export * from "./DemoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3f980",
  null
  
)

export default component.exports